import { render, staticRenderFns } from "./estate-video-section.vue?vue&type=template&id=3dbceece&"
import script from "./estate-video-section.vue?vue&type=script&lang=js&"
export * from "./estate-video-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports